import { render } from "./UserDetalle.vue?vue&type=template&id=84488c8a&scoped=true"
import script from "./UserDetalle.vue?vue&type=script&lang=js"
export * from "./UserDetalle.vue?vue&type=script&lang=js"

import "./UserDetalle.vue?vue&type=style&index=0&id=84488c8a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84488c8a"]])

export default __exports__